import { useFormikContext } from "formik";
import Typography from "@mui/material/Typography";
import { CreateCampaignData } from "../../../types/campaign";
import Stack from "@mui/material/Stack";
import { format } from "date-fns";
import { useMemo } from "react";
import { OBJECTIVE_CAMPAIGN } from "../../../utils/constants";
import SmsIcon from "../../../assets/campaign/sms.png";
import WhatsAppIcon from "../../../assets/campaign/whatsapp.png";
import EmailIcon from "../../../assets/campaign/email.png";
import { useStyles } from "./styles";
import { isEmpty, map } from "lodash";
import { PreviewHtml } from "../../PreviewHtml";

export function Review() {
  const styles = useStyles();
  const formik = useFormikContext<CreateCampaignData>();

  const formatDate = (date: Date | null): Date | String | null => {
    if (!date) {
      return date;
    }

    return format(date, "dd/MM/yyyy HH:mm");
  };

  const objective = useMemo(() => {
    return OBJECTIVE_CAMPAIGN.find(
      (type) => type.id === formik.values.campaignSendingType
    );
  }, [formik.values.campaignSendingType]);

  const iconChannel = useMemo(() => {
    switch (formik.values.channel) {
      case "sms":
        return SmsIcon;
      case "whatsapp":
        return WhatsAppIcon;
      case "email":
        return EmailIcon;
      default:
        return SmsIcon;
    }
  }, [formik.values.channel]);

  const errors = useMemo(() => {
    const errorsFormik = Object.values(formik.errors);
    return errorsFormik as string[];
  }, [formik.errors]);

  return (
    <Stack spacing={4}>
      <Stack direction="row" spacing={1} alignItems="center">
        <img className={styles.imgIcon} alt="icon-channel" src={iconChannel} />
        <Typography color="primary">Resumo</Typography>
      </Stack>
      {!isEmpty(errors) && (
        <>
          <Stack spacing={1}>
            <Typography>Erros na campanha</Typography>
            {map(errors, (error) => {
              return (
                <Typography variant="button" color="red">
                  {error}
                </Typography>
              );
            })}
          </Stack>
        </>
      )}
      <Typography>Objetivo: {objective.label}</Typography>
      <Typography>Nome: {formik.values.name}</Typography>
      <Typography>Audiência: {formik.values.nameInsight}</Typography>
      <Typography>
        <>Data de início: {formatDate(formik.values.startDate)}</>
      </Typography>
      <Typography>
        <>Data de término: {formatDate(formik.values.endDate)}</>
      </Typography>
      <Typography>
        <>Data de envio: {formatDate(formik.values.sendDate)}</>
      </Typography>
      {formik.values.whatsAppInstance ? (
        <Typography>
          Instancia: {formik.values.whatsAppInstance.name}
        </Typography>
      ) : null}
      {formik.values.channel === "email" ? (
        <>
          <Typography>Preview</Typography>
          <PreviewHtml link={formik.values.message} />
        </>
      ) : (
        <Typography>Mensagem: {formik.values.message}</Typography>
      )}
    </Stack>
  );
}
